<template>
  <div ref="modalContainer"></div>
  <a-card class="content-wrapper">
    <template #title>
      <CardHeader></CardHeader>
    </template>
    <div class="body-content">
      <a-form layout="inline">
        <a-form-item label="车场名称">
          <a-input
            v-model:value="params.name"
            placeholder="输入车场名称"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item label="状态">
          <a-select
            v-model:value="params.status"
            notFoundContent="暂无数据"
            style="width: 200px"
            placeholder="请选择"
            allow-clear
            :options="parkingStatus"
          ></a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="doQuery">
            <template #icon>
              <SearchOutlined />
            </template>
            查询
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            perm="parking:curb:add"
            class="btn-success"
            @click="showAddModal"
          >
            <template #icon>
              <PlusCircleOutlined />
            </template>
            添加
          </a-button>
        </a-form-item>
      </a-form>
      <div style="padding: 4px 0">
        <a-table
          row-key="id"
          table-layout="fixed"
          :data-source="dataList.list"
          :columns="columns"
          :loading="loading"
          :pagination="false"
          :scroll="{ y: 500 }"
          bordered
        >
          <template #status="{ text }">
            <a-tag :color="text == 1 ? 'green' : 'red'">
              {{ text == 1 ? "启用" : "停用" }}
            </a-tag>
          </template>
          <template #operation="{ record }">
            <div>
              <TipButton
                perm="parking:curb:edit"
                title="详情"
                @btnClick="showDetailModal(record.id)"
              >
                <template #default>
                  <ContainerOutlined />
                </template>
              </TipButton>
              <TipButton
                perm="parking:curb:edit"
                btn-class="btn-success"
                title="编辑"
                @btnClick="showEditModal(record.id)"
              >
                <template #default>
                  <EditOutlined />
                </template>
              </TipButton>
              <TipButton
                perm="parking:curb:del"
                btn-class="btn-danger"
                title="删除"
                @btnClick="delItem(record.id)"
              >
                <template #default>
                  <DeleteOutlined />
                </template>
              </TipButton>
            </div>
          </template>
        </a-table>
      </div>
      <a-pagination
        v-model:current="page"
        v-model:page-size="pageSize"
        :total="total"
        :show-total="total => `${total}条数据`"
        @change="currentChange"
      >
      </a-pagination>
    </div>
  </a-card>
  <add
    v-if="addShow"
    :modal-ref="$refs.modalContainer"
    @close="hideAddModal"
  ></add>
  <edit
    v-if="editShow"
    :id="currentId"
    :modal-ref="$refs.modalContainer"
    @close="hideEditModal"
  ></edit>
  <detail
    v-if="detailShow"
    :id="currentId"
    :modal-ref="$refs.modalContainer"
    @close="hideDetailShow"
  ></detail>
</template>

<script>
import CardHeader from "@/components/CardHeader";
import useParkingCurb from "@/hooks/parking/useParkingCurb";
import usePagination from "@/hooks/usePagination";
import useAddExit from "@/hooks/useAddExit";
import { onMounted, ref } from "vue";
import Add from "@/views/Parking/Curb/components/Add";
import Edit from "@/views/Parking/Curb/components/Edit";
import Detail from "@/views/Parking/Curb/components/Detail";
import useMessage from "@/hooks/useMessage";
import { deleteParkingLot } from "@/api/parking/parkingLotApi";
import TipButton from "@/components/TipButton";

export default {
  name: "index",
  components: {
    Edit,
    Add,
    Detail,
    CardHeader,
    TipButton,
  },
  setup() {
    const {
      params,
      dataList,
      total,
      parkingStatus,
      loading,
      columns,
      loadData,
    } = useParkingCurb();

    const { page, pageSize, currentChange, doQuery, doRefresh } =
      usePagination(loadData);

    const detailShow = ref(false);

    const showDetailModal = id => {
      console.log("==3===" + detailShow.value);
      currentId.value = id;
      detailShow.value = true;
    };

    const hideDetailShow = () => {
      console.log("===1==" + detailShow.value);
      detailShow.value = false;
      console.log("===2==" + detailShow.value);
    };

    const {
      currentId,
      addShow,
      editShow,
      showAddModal,
      showEditModal,
      hideAddModal,
      hideEditModal,
    } = useAddExit(doQuery);

    const { showConfirm, showLoading, closeLoading, showTipMessage, showErr } =
      useMessage();

    onMounted(() => {
      loadData(page.value, pageSize.value);
    });

    const delItem = async id => {
      let action = await showConfirm(
        "车场删除后，与收费规则的相关关系也会删除，确认删除?",
      );
      if (action) {
        await showLoading("正在删除，请稍后...");
        try {
          await deleteParkingLot(id);
          await closeLoading();
          await showTipMessage("删除成功", "success");
          doQuery();
        } catch (e) {
          await closeLoading();
          await showErr(e);
        }
      }
    };

    return {
      params,
      page,
      pageSize,
      total,
      parkingStatus,
      loading,
      currentChange,
      dataList,
      doQuery,
      doRefresh,
      columns,

      currentId,
      addShow,
      editShow,
      detailShow,
      showEditModal,
      showAddModal,
      hideAddModal,
      hideEditModal,
      showDetailModal,
      hideDetailShow,
      delItem,
    };
  },
};
</script>

<style scoped></style>
